import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';
import Checkbox from '@mui/material/Checkbox'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import HelperText from './HelperText'
import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    marginTop: theme.spacing(2),
  },
}))

const MultipleCheckboxField: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {

  const {
    field: {
      name,
      value,
    },
    form: {
      setFieldValue,
    },
    disabled,
    error,
    touched,
    item,
    readonly,
  } = getProps(props)
  
  const classes = useStyles()

  const title = item.title || name
  const useValue = value || {}

  return (
    <FormControl component="fieldset" className={ classes.root } disabled={ disabled }>
      <FormLabel component="legend">{ title }</FormLabel>
      <FormGroup
        row={ item.meta && item.meta.row ? true : false }
      >
        {
          (item.options || []).map((option, i) => {
            option = typeof(option) === 'string' ? {
              title: option,
              value: option,
            } : option

            const checked = useValue[option.value] ? true : false

            return (
              <FormControlLabel
                key={ i }
                control={
                  <Checkbox
                    name={ `${name}-${i}` }
                    disabled={ readonly }
                    checked={ checked }
                    onChange={ () => {
                      const newValue = Object.assign({}, useValue)
                      if(!checked) {
                        newValue[option.value] = true
                      }
                      else {
                        delete(newValue[option.value])
                      }
                      setFieldValue(name, newValue)
                    }}
                    value={ `${name}-${i}` }
                  />
                }
                label={ option.title }
              />
            )
          })
        }
      </FormGroup>
      <HelperText
        helperText={ item.helperText }
        error={ error ? true : false }
        touched={ touched }
      />
    </FormControl>
  )
}

export default MultipleCheckboxField